import React from 'react';
import { tr } from '../../i18n';
import './system-states.css';

type LoadingStateProps = {
  title?: string;
  skeletonLines?: number;
};

const Spinner: React.FC = () => (
  <span style={{
    display: 'inline-block',
    width: 22,
    height: 22,
    borderRadius: '50%',
    border: '2.5px solid var(--border-medium)',
    borderTopColor: 'var(--accent-solid)',
    animation: 'spin 0.75s linear infinite'
  }} />
);

const LoadingState: React.FC<LoadingStateProps> = ({
  title = tr.shell.systemStates.loadingTitle,
  skeletonLines = 3
}) => (
  <>
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    <div className="sys-state">
      <div className="sys-state-icon-wrap sys-state-icon-wrap--accent">
        <Spinner />
      </div>
      <h3 className="sys-state-title">{title}</h3>
      <div className="sys-state-skeletons">
        {Array.from({ length: skeletonLines }).map((_, i) => (
          <div
            key={i}
            className="sys-state-skeleton-line"
            style={{ width: i % 2 === 0 ? '100%' : '72%' }}
          />
        ))}
      </div>
    </div>
  </>
);

export default LoadingState;
